<div class="material-datatables">
  <table id="holydaystables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
    <thead>
      <tr>
          <th>{{ dataTable.headerRow[0] }}</th>
          <th class="text-center">{{ dataTable.headerRow[1] }}</th>
          <th class="text-center">{{ dataTable.headerRow[2] }}</th>
          <th class="text-center">{{ dataTable.headerRow[3] }}</th>
          <th class="text-center">{{ dataTable.headerRow[4] }}</th>
          <th class="text-center">{{ dataTable.headerRow[5] }}</th>
          <th class="text-center" *ngIf="actions">{{ dataTable.headerRow[6] }}</th>
          <th class="disabled-sorting text-right" style="text-align: right;" *ngIf="actions">Actions</th>
      </tr>
  </thead>

  <tbody>
      <tr id="itemweight{{row[0]}}" *ngFor="let row of dataTable.dataRows; let i = index">
          <td>{{row[0]}}</td>
          <td class="text-center">{{row[1] | date:'MM-dd-yyyy'}}</td>
          <td class="text-center">{{row[2]}}</td>
          <td class="text-center">{{row[3] | date:'MM-dd-yyyy'}}</td>
          <td class="text-center">{{row[4]}}</td>
          <td class="text-center" title="{{row[5]}}" >{{row[5] | slice:0:15}}{{row[5].length > 15 ? '...' : ''}}</td>
          <td class="text-center" *ngIf="actions">
              <label *ngIf="row[6] === '0'" style="color: blue">pending</label>
              <label *ngIf="row[6] === '1'" style="color: green">approved</label>
              <label *ngIf="row[6] === '2'" style="color: red">denied</label>
          </td>
          <td class="text-right" *ngIf="actions">
              <!-- <a class="btn btn-link btn-info btn-just-icon" (click)="saveEmit('show',row[0], row)"><i class="material-icons">remove_red_eye</i></a> -->
              <!-- <a class="btn btn-link btn-dark btn-just-icon" (click)="saveEmit('print',row[0], row)"><i class="material-icons">local_printshop</i></a> -->
              <a *ngIf="row[6] === '0'" (click)="saveEmit('delete',row[0], row)" class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a>
          </td>
      </tr>
  </tbody>
    </table>
</div>
